import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, TrendingUpIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
export function ClosingSection() {
  return <section className="py-20 px-4 bg-gradient-to-b from-transparent to-black/60" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <motion.h2 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-15">
          Tienes Dos Caminos Ahora Mismo:
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gray-900/50 border border-gray-700 rounded-xl p-8 opacity-60" data-id="element-17">
            <div className="flex items-center gap-3 mb-4" data-id="element-18">
              <XCircleIcon className="w-10 h-10 text-red-500" data-id="element-19" />
              <h3 className="text-2xl font-bold text-red-400" data-id="element-20">Camino A:</h3>
            </div>
            <p className="text-gray-400 leading-relaxed" data-id="element-21">
              No haces nada. Siguen pasando los meses, sigues cansado en el
              mismo trabajo físico y ves cómo los demás aprovechan la IA.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gradient-to-br from-amber-900/30 to-black border-2 border-amber-500 rounded-xl p-8 shadow-xl shadow-amber-500/20" data-id="element-22">
            <div className="flex items-center gap-3 mb-4" data-id="element-23">
              <TrendingUpIcon className="w-10 h-10 text-amber-500" data-id="element-24" />
              <h3 className="text-2xl font-bold text-amber-400" data-id="element-25">Camino B:</h3>
            </div>
            <p className="text-gray-200 leading-relaxed" data-id="element-26">
              Inviertes menos de lo que cuesta una cena fuera en tu futuro.
              Aprendes la habilidad más demandada del siglo y empiezas a ganar
              en dólares desde tu casa.
            </p>
          </motion.div>
        </div>

        <motion.div id="cta-final" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center" data-id="element-27">
          <motion.a href="https://aifreelancegoldmine.com/cart/46344678604961:1" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="relative inline-block bg-gradient-to-r from-amber-500 to-amber-600 text-black font-bold text-lg px-12 py-6 rounded-full shadow-2xl hover:shadow-amber-500/50 transition-all duration-300" data-id="element-28">
            <motion.span animate={{
            opacity: [1, 0.7, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="absolute inset-0 bg-amber-400 rounded-full blur-xl opacity-50" data-id="element-29" />
            <span className="relative" data-id="element-30">
              SÍ, QUIERO EMPEZAR MI GOLDMINE — ACCESO INMEDIATO POR $47
            </span>
          </motion.a>
        </motion.div>
      </div>
    </section>;
}